module.exports = __webpack_public_path__ + "static/media/15-ball.3dd49711.png";